import { render, staticRenderFns } from "./question-store.vue?vue&type=template&id=d1950d72&scoped=true"
import script from "./question-store.vue?vue&type=script&lang=ts"
export * from "./question-store.vue?vue&type=script&lang=ts"
import style0 from "./question-store.vue?vue&type=style&index=0&id=d1950d72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1950d72",
  null
  
)

export default component.exports